/**
 * Normalize a Hiring record (from API) into the shape expected by ApplicantCard.
 */
export function normalizeHiringRow(hiring) {
  const normalizedEmployeeId = hiring?.employeeId ?? hiring?.employee?.id ?? null;
  const emp = hiring?.employee ?? {};
  const name = [emp.name, emp.surname].filter(Boolean).join(' ') || emp.name || '';

  return {
    id: hiring?.id ?? normalizedEmployeeId,
    employeeId: normalizedEmployeeId,
    jobPostId: hiring?.jobOfferId ?? hiring?.jobPostId ?? null,
    employee: {
      name,
      surname: emp.surname ?? '',
      position: emp.position ?? '',
      available: emp.available ?? '',
      schedule: emp.schedule ?? '',
      profileImageUrl: emp.profileImageUrl ?? '',
      yearsOfExperience: emp.yearsOfExperience ?? 0
    },
    hiringId: hiring?.id,
    hiringStatus: hiring?.status,
    acceptanceDate: hiring?.acceptanceDate
  };
}

